/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Console_Prompt_Copied_StatusInputs */

const en_console_prompt_copied_status = /** @type {(inputs: Console_Prompt_Copied_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt copied to clipboard.`)
};

const zh_hans1_console_prompt_copied_status = /** @type {(inputs: Console_Prompt_Copied_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提示词已复制到剪贴板。`)
};

const pt_br2_console_prompt_copied_status = /** @type {(inputs: Console_Prompt_Copied_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt copiado para a área de transferência.`)
};

const es_console_prompt_copied_status = /** @type {(inputs: Console_Prompt_Copied_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt copiado al portapapeles.`)
};

const fr_console_prompt_copied_status = /** @type {(inputs: Console_Prompt_Copied_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt copié dans le presse-papiers.`)
};

const de_console_prompt_copied_status = /** @type {(inputs: Console_Prompt_Copied_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt in die Zwischenablage kopiert.`)
};

const ru_console_prompt_copied_status = /** @type {(inputs: Console_Prompt_Copied_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промпт скопирован в буфер обмена.`)
};

const it_console_prompt_copied_status = /** @type {(inputs: Console_Prompt_Copied_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt copiato negli appunti.`)
};

/**
* | output |
* | --- |
* | "Prompt copied to clipboard." |
*
* @param {Console_Prompt_Copied_StatusInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const console_prompt_copied_status = /** @type {((inputs?: Console_Prompt_Copied_StatusInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Console_Prompt_Copied_StatusInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_console_prompt_copied_status(inputs)
	if (locale === "pt-BR") return pt_br2_console_prompt_copied_status(inputs)
	if (locale === "es") return es_console_prompt_copied_status(inputs)
	if (locale === "fr") return fr_console_prompt_copied_status(inputs)
	if (locale === "de") return de_console_prompt_copied_status(inputs)
	if (locale === "ru") return ru_console_prompt_copied_status(inputs)
	if (locale === "it") return it_console_prompt_copied_status(inputs)
	return en_console_prompt_copied_status(inputs)
});